import PaginationComponent, {
  PaginationComponentProps,
  testId,
} from './PaginationComponent';

export default PaginationComponent;
export type { PaginationComponentProps };

export { testId };
